<template>
	<div class="job-evaluation-verbs">
		<div class="tabs tw-flex">
			<div
				v-for="(item, index) in verbsList"
				class="tw-w-1/3 tw-text-center tab"
				@click="changeTab(index)"
				:class="{
					'selected': currentTab === index,
					'disabled': index !== filledLevel && filledLevel
				}"
			>
				<p class="uppercase">{{ item.name }}</p>
			</div>
		</div>
		<div class="tw-px-8 tw-py-4 verbs-options">
			<div v-for="(item, commandKey) in verbsList">
				<div v-if=" currentTab === commandKey" class="tw-flex tw-flex-wrap tw--mx-4">
					<div v-for="(verb, verbIndex) in item.details" class="tw-w-1/3 tw-px-4">
						<v-checkbox
							v-model="jobCopied[commandKey][verb.code]"
							:label="verb.description"
							:key="verbIndex"
							hide-details
							color="success"
							style="background: white"
							class="custom-checkbox"
							@change="onCheckboxChange"
						>
						</v-checkbox>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { head, keys, pipe, clone, values, prop, filter,
	any, equals, assoc, toPairs, propEq, map, contains } from 'ramda';
import { commandMap } from './../../utils/helpers';

export default {
	name: 'c-job-verbs-selector',
	beforeMount() {
		this.jobSelected = this.selectedJob;
		this.verbsList = this.verbsInfo;
	},
	props: {
		verbsInfo: {
			default: () => ({}),
		},
		selectedJob: {
			default: () => ({}),
		},
	},
	data() {
		return {
			currentTab: '',
			jobCopied: {
				highCommand: {},
				mediumCommand: {},
				lowCommand: {},
			},
			verbsSelected: [],
			jobSelected: {},
			verbsList: {},
		};
	},
	mounted() {
		this.currentTab = pipe(keys, head)(this.verbsList);
	},
	computed: {
		filledLevel() {
			return pipe(
				keys,
				filter(levelKey => any(equals(true), values(prop(levelKey, this.jobCopied)))),
				head,
			)(this.verbsList);
		},
		typeVerbs() {
			return prop(this.filledLevel, commandMap);
		},
	},
	watch: {
		jobSelected: {
			handler(val) {
				this.jobCopied = clone(val);
				if (this.filledLevel) {
					this.currentTab = this.filledLevel;
				}
			},
		},
	},
	methods: {
		changeTab(index) {
			if (index !== this.filledLevel && this.filledLevel) return;
			this.currentTab = index;
		},
		onCheckboxChange() {
			this.jobCopied = assoc('typeVerb', this.typeVerbs, this.jobCopied);
			if (this.filledLevel) {
				const selectedData = this.jobCopied[this.filledLevel];
				const filterData = pipe(
					toPairs,
					filter(propEq(1, true)),
					map(head),
				)(selectedData);
				const selectObjectVerbs = this.verbsList[this.filledLevel].details;
				this.verbsSelected = filter(
					vrb => contains(vrb.code, filterData),
					selectObjectVerbs,
				);
				this.$emit('selectedJobDataChanged', this.verbsSelected);
			}
		},
	},
};
</script>

<style lang='scss' scoped>
.job-evaluation-verbs {
	border-top: solid 1px var(--app-color-gray);
	.tabs {
		user-select: none;
		.tab {
			padding-top: 20px;
			cursor: pointer;
			font-size: 12px;
			color: var(--app-color-primary);
			&.selected {
				border-bottom: solid 2px var(--app-color-primary);
			}
			&.disabled {
				cursor: not-allowed;
				color: var(--app-color-info);
			}
			border-bottom: solid 2px var(--app-color-gray);
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/job-profile/components/first-step/c-job-verbs-selector.vue